// extracted by mini-css-extract-plugin
module.exports = {"article":"HomepageArticles-module--article--p46yo","publishDate":"HomepageArticles-module--publishDate--1jvBm"};